/** Helpers for presenting the archive's Nostr profile (kind 0). */

/** Fallback summary when the profile has no usable bio text. */
export const DEFAULT_SUMMARY =
  'A censorship-resistant archive of rare evidence, legal documents and geopolitical history.';

/**
 * Remove the inscription/ordiscan promo lines from the profile bio so they
 * don't show in the archive header. Matches the "Inscribed archive & directory"
 * / "#911txts" line and any ordiscan.com link, then tidies blank lines.
 */
export function cleanAbout(about: string): string {
  return about
    .split('\n')
    .filter((line) => {
      const l = line.toLowerCase();
      if (l.includes('inscribed archive')) return false;
      if (l.includes('#911txts')) return false;
      if (l.includes('ordiscan.com')) return false;
      // These now live in the classification strip, so hide them from the bio.
      if (l.includes('foia disclosures')) return false;
      if (l.includes('wikileaks files')) return false;
      if (l.includes('media propaganda')) return false;
      if (l.includes('penttbomb') || l.includes('twinbom')) return false;
      return true;
    })
    .join('\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
}

/** Hide ordiscan links shown as the profile website. */
export function isHiddenWebsite(url: string): boolean {
  return url.toLowerCase().includes('ordiscan.com');
}

/**
 * Where to open the archive's profile in a Nostr client. njump is
 * client-agnostic: it renders the profile and offers to open it in the
 * reader's own app.
 */
export function profileUrlFor(npub: string): string {
  return `https://njump.me/${npub}`;
}
